import React, { useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AuthContext from '../Navbar/AuthContext';

const GoogleAuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login, verifyAuth } = useContext(AuthContext);

  useEffect(() => {
    const handleGoogleAuth = () => {
      try {
        // Extract all parameters from URL
        const accessToken = searchParams.get('accessToken');
        const refreshToken = searchParams.get('refreshToken');
        const userId = searchParams.get('userId');
        const userType = searchParams.get('userType');
        const userName = searchParams.get('userName');
        const userEmail = searchParams.get('userEmail');
        const accessTokenExpiresAt = searchParams.get('accessTokenExpiresAt');

        if (accessToken && refreshToken && userId && userType) {
          // Store all authentication data in localStorage
          localStorage.setItem('accessToken', accessToken);
          localStorage.setItem('refreshToken', refreshToken);
          localStorage.setItem('userId', userId);
          localStorage.setItem('userRole', userType);
          localStorage.setItem('userName', userName || '');
          localStorage.setItem('userEmail', userEmail || '');
          
          if (accessTokenExpiresAt) {
            localStorage.setItem('accessTokenExpiresAt', accessTokenExpiresAt);
          }
          
          // Force update the auth state immediately
          if (verifyAuth) {
            const authData = verifyAuth();
            
            // If verifyAuth doesn't update the UI immediately, force a state update
            // by manually triggering a storage event
            window.dispatchEvent(new Event('storage'));
          }
          
          // Redirect to home page
          navigate('/', { replace: true });
        } else {
          // If required data is missing, redirect to login
          console.error('Missing authentication data');
          navigate('/signin', { replace: true, state: { error: 'Authentication failed' } });
        }
      } catch (error) {
        console.error('Google auth handling error:', error);
        navigate('/signin', { replace: true, state: { error: 'Authentication error' } });
      }
    };

    handleGoogleAuth();
  }, [navigate, searchParams, verifyAuth]);

  return (
    <div style={styles.loadingContainer}>
      <div style={styles.spinner}></div>
      <p>Completing login...</p>
    </div>
  );
};

const styles = {
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    fontSize: '18px',
    color: '#4f46e5',
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #4f46e5',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginBottom: '16px',
  },
};

export default GoogleAuthCallback;